import { inject } from "@angular/core";
import { CanMatchFn } from "@angular/router";
import { FeatureFlagsService, Flag } from "../services/feature-flags.service";

export const FeatureFlagGuard =
  (flag: Flag, state: boolean): CanMatchFn =>
  () => {
    const featureFlags = inject(FeatureFlagsService);
    return featureFlags.isEnabled(flag).then((value) => value === state);
  };
